import { render, staticRenderFns } from "./TemplatesContact.vue?vue&type=template&id=7df64eb6"
import script from "./TemplatesContact.vue?vue&type=script&lang=js"
export * from "./TemplatesContact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports